module.exports = __webpack_public_path__ + "95a1e8408bf0f88ec6ff225e01a42bd3.png";